import { useMutation, useQueryClient } from '@tanstack/react-query';

interface ReplaceArtifactVariables {
  id: string;
  formData: FormData;
}

export const useReplaceArtifactContent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, formData }: ReplaceArtifactVariables) => {
      const token = localStorage.getItem('token');
      const apiBase = process.env.REACT_APP_API_BASE;
      const url = `${apiBase}/artifacts/${id}/content`;

      const request: Response = await fetch(url, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: formData
      });
      const responseData = await request.json();

      if (request.status >= 400) {
        const response: iResponse<any> = {
          code: request.status,
          error: responseData as ResponseErrorObj
        };
        throw response;
      }

      const response: iResponse<any> = {
        data: responseData,
        code: request.status
      };

      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['artifacts'] });
    }
  });
};

export default useReplaceArtifactContent;
